import { render } from "./refresh.vue?vue&type=template&id=7c143f70"
import script from "./refresh.vue?vue&type=script&lang=js"
export * from "./refresh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__